export const queryParamsToObject = (queryParams: string) => {
  const obj = {};
  const params = new URLSearchParams(queryParams);
  Array.from(params.keys()).forEach((key) => {
    const value = params.get(key);
    if (value === 'false' || value === 'true') {
      obj[key] = value === 'true' ? true : false;
    } else if (value?.includes(',')) {
      obj[key] = value.split(',');
    } else if (
      key === 'propertyTypes' ||
      key === 'listingTypes' ||
      key === 'selectedAmenities' ||
      key === 'views' ||
      key === 'garageType' ||
      key === 'listingStatus' ||
      key === 'selectedStates' ||
      key === 'selectedProvinces'
    ) {
      obj[key] = [value];
    } else {
      obj[key] = value;
    }
  });
  return obj;
};
